import React from 'react'
import Header from '../components/Header'
import StepDiv from '../components/StepDiv'

import logo from '../logo.png';
import adPortal from '../adportal.png';
import nielsen from '../nielsen.png';
import nielsenLogo from '../nielsenLogo.png';

function ValueItem(props) {
  return (
    <div className='value-item'>
      <span className="heading3-light">
        {props.heading}
      </span>
      <p style={{ fontFamily: 'Euclid-Light', color: '#ccc', lineHeight: '0.7cm' }}>
        {props.para}
      </p>
    </div>
  )
}

function Advertisers() {
  return (
    <>
      <div className='App'>
        <Header />
        {/* Hero */}
        <section>
          <div className='section hero hero-ad'>

            <div style={{ flex: 3 }}>
              <h1 className="heading1">
                Out-door <br></br>Advertisement
              </h1>
              <h1 className="heading1">
                Just got better...
              </h1>

              {/* Form */}
              <p className='formHeader'>
                The performance-driven ad-tech platform for brands. <br></br>
                Boost brand identity and strength with tracked wrapped vehicles accross the country.
              </p>

              <a href='https://docs.google.com/forms/d/e/1FAIpQLScJ4iDgM76enuwTKP8QmjjBK5PyvgWFn49YzPBTBprXfyGNiQ/viewform?vc=0&c=0&w=1&flr=0'>
                <button type="submit" className='Send'>REQUEST DEMO</button>
              </a>

            </div>

            <div style={{ flex: 2 }}>
              <img src={adPortal} className="appMockup" alt="App Mockup" />
            </div>
          </div>
        </section>

        {/* Steps */}
        <section>
          <div className='section'>

            <div style={{ flex: 3, marginBottom: '10%' }}>
              <h1 className="heading2">
                How it works
              </h1>

              <StepDiv
                stepNumber='1'
                stepTitle='Choose Location &#127757;'
                stepDescription="With the ability to run national, regional and local campaigns, you can target the audience you want to reach where you want to reach them."
              />

              <StepDiv
                stepNumber='2'
                stepTitle='Refine Audience Targeting &#128064;'
                stepDescription="Refine the campaign geofence in each market by Demographic, Psychographic, and ABM targeting."
              />

              <StepDiv
                stepNumber='3'
                stepTitle='We do the rest &#128208;'
                stepDescription="With drivers using our app and a nationwide certified installer network, we manage every step of onboarding drivers, streamlining the creative and production process and ensuring brand safety is always #1."
              />

            </div>
          </div>
        </section>

        {/* Added Value */}
        <section style={{ backgroundColor: "#444", padding: '5%', marginBottom: '5%', borderRadius: '30px' }}>
          <center>
            <h1 className="heading2-light">
              We don't just wrap vehicles
            </h1>
          </center>

          <div className='section-row'>
            <ValueItem
              heading="Retarget"
              para="Retarget the audience exposed to OohBit vehicles across Programmatic Display, Mobile, Native, Connected TV (CTV) and Streaming Audio."
            />
            <ValueItem
              heading="Measure"
              para="Measure the impact of the out of home (OOH) impressions we produce with OOH impressions tracking technology in a dashboard online."
            />
            <ValueItem
              heading="Attribute"
              para="Attribute wrapped vehicle exposure to online, in-app or foot traffic engagement."
            />
          </div>
        </section>
      </div>

      {/* Why Us */}
      <section style={{ backgroundColor: "#222", padding: '5%', borderRadius: '30px', margin: '10%' }}>
        <center>
          <h1 className="heading2-light">
            Why Us?
          </h1>
          <p style={{ fontFamily: 'Euclid-Light', color: '#ccc', lineHeight: '0.7cm' }}>
            Nielsen's 2019 out-of-home advertising report shows wrapped vehicles as the Most Noticed medium on the road.
            <br></br>The percentage of people who remember seeing the specified medium in the past 30 days.<br></br><br></br>
            <span className='heading3'>Proven to be #1 most memorable and noticed meduim on the road</span>
          </p>
        </center>

        <div className='section-col'>
          <img src={nielsen} className="img" alt="App Mockup" />
          <img src={nielsenLogo} className="img-s" alt="App Mockup" />
        </div>

        <center style={{marginTop: '5%'}}>
          <a href='https://www.eazyads.co.za/sitepad-data/uploads/2021/12/Nielsen-OUT-OF-HOME-ADVERTISING-STUDY.pdf'>
            <button type="submit" className='Send'>FULL REPORT</button>
          </a>
        </center>
      </section>

      {/* Footer */}
      <section style={{ marginTop: "10%", backgroundColor: "#444", padding: '10%' }}>
        <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <h1 className="heading1-light">
              Reach Us
            </h1>
            <p className='oohbit-p'>
              <span className='oohbit'>info@oohbit.co.tz</span><br></br>
              <span className='oohbit'>+255 763 144 515</span><br></br><br></br>
              Copyright <span className='oohbit'>{new Date().getFullYear()}</span> OohBit
            </p>
          </div>

          <div>
            <img
              src={logo}
              className="App-logo"
              alt="logo"
            />
          </div>
        </div>

      </section>
    </>

  )
}

export default Advertisers